import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { CooperateService } from "../api";
import { toast } from "react-toastify";
import { ACCESS_TOKEN, USER_KEY } from "../../utility/auth";

export const actionGetListContactCooperate = createAsyncThunk(
  "common/list-contact-cooperate",
  async (data, { rejectWithValue }) => {
    try {
      const res = await CooperateService.doGetListContactCooperate(data);
      if (!res.data.status) {
        // toast.success(res.data.message);
        return res.data;
      } else {
        toast.error(res.data.message);
        return rejectWithValue(res.data);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      toast.error(message);
      return rejectWithValue(message);
    }
  }
);

export const actionContactRegister = createAsyncThunk(
  "common/contact-register",
  async (data, { rejectWithValue }) => {
    try {
      const res = await CooperateService.doContactRegister(data);
      if (!res.data.status) {
        toast.success(res.data.message);
        return res.data;
      } else {
        toast.error(res.data.message);
        return rejectWithValue(res.data);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      toast.error(message);
      return rejectWithValue(message);
    }
  }
);

export const actionUpdateContactCooperate = createAsyncThunk(
  "common/update-contact-cooperate",
  async (data, { rejectWithValue }) => {
    try {
      const res = await CooperateService.doUpdateContactCooperate(data);
      if (!res.data.status) {
        toast.success(res.data.message);
        return res.data;
      } else {
        toast.error(res.data.message);
        return rejectWithValue(res.data);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      toast.error(message);
      return rejectWithValue(message);
    }
  }
);

const cooperateSlice = createSlice({
  name: "cooperate",
  initialState: {
    listContactCooperate: {
      loading: false,
      data: null,
      error: "",
    },
    contactRegister: {
      loading: false,
      data: null,
      error: "",
    },
    updateContactCooperate: {
      loading: false,
      data: null,
      error: "",
    },
  },

  reducers: {},
  extraReducers: (builder) => {
    builder
      // change pass
      .addCase(actionGetListContactCooperate.pending, (state) => {
        state.listContactCooperate.loading = true;
      })
      .addCase(actionGetListContactCooperate.fulfilled, (state, action) => {
        state.listContactCooperate.loading = false;
        state.listContactCooperate.data = action.payload;
      })
      .addCase(actionGetListContactCooperate.rejected, (state, action) => {
        state.listContactCooperate.loading = false;
        state.listContactCooperate.error =
          action.error.message || "Something went wrong";
      })
      // contact Register
      .addCase(actionContactRegister.pending, (state) => {
        state.contactRegister.loading = true;
      })
      .addCase(actionContactRegister.fulfilled, (state, action) => {
        state.contactRegister.loading = false;
        state.contactRegister.data = action.payload;
      })
      .addCase(actionContactRegister.rejected, (state, action) => {
        state.contactRegister.loading = false;
        state.contactRegister.error =
          action.error.message || "Something went wrong";
      })
      // update Contact Cooperate
      .addCase(actionUpdateContactCooperate.pending, (state) => {
        state.updateContactCooperate.loading = true;
      })
      .addCase(actionUpdateContactCooperate.fulfilled, (state, action) => {
        state.updateContactCooperate.loading = false;
        state.updateContactCooperate.data = action.payload;
      })
      .addCase(actionUpdateContactCooperate.rejected, (state, action) => {
        state.updateContactCooperate.loading = false;
        state.updateContactCooperate.error =
          action.error.message || "Something went wrong";
      });
  },
});

export default cooperateSlice.reducer;
export const { actions, reducer } = cooperateSlice;
